<template>
    <div>
        <v-row 
            class="px-0 mx-2 pb-0" 
            justify="center"
        >
            <v-col
                class="action-link align-content-center"
                cols="auto"
                v-for="(channel,index) in channels"
                v-bind:key="channel.ChannelNumDisplay"
                @click="liteChannel(index)"
            >
                <channel :channel="channel" :index="index" :lit="index == currentLitChannel" />
            </v-col>
        </v-row>
        <v-row 
            v-if="expanded"
            class="px-2"
        >
            <v-col cols="12" class="pt-0">
                <div class="font-weight-bold caption">
                    {{ currentLitChannelDetails.channelCallsignDisplay}} Channel
                    <template v-if="currentLitChannelDetails.channelNumDisplay != currentLitChannelDetails.channelCallsignDisplay"> - 
                        {{ currentLitChannelDetails.channelNumDisplay }}
                    </template>
                </div>
                <div class="caption">
                   {{currentLitChannelDetails.nonDTV ? 'Not available on DIRECTV. ' : ''}}{{ currentLitChannelDetails.ChannelDescriptionDisplay }}
                </div>
                <div class="caption" v-if="currentLitChannelDetails.IncludedIn.length">
                    <strong>INCLUDED IN:</strong>
                    <v-chip 
                        class="mr-1"
                        :dark="include.TagColor != 'yellow'"
                        :color="include.TagColor"
                        v-for="(include,index) in currentLitChannelDetails.IncludedIn" v-bind:key="index"
                        x-small
                        >
                            <span class="my-auto">
                                {{ include.TagTitle }}
                            </span>
                    </v-chip>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import Channel from "./Channel";

export default {
    name: "Expanded",
    components: {
        Channel
    },
    props: {
        event: Object
    },
    computed: {
        channels() {
            return this.event.MatchingBroadcastEvents;
        },
        currentLitChannelDetails() {
            return this.event.MatchingBroadcastEvents[this.currentLitChannel];
        }
    },
    data() {
        return {
            currentLitChannel: null,
            expanded: false
        }
    },
    methods: {
        liteChannel(index) {
            this.$gtag.event("api", {
                event_category: "event",
                event_label: "expand_event"
            });
            if (this.currentLitChannel == index) {
                this.currentLitChannel = null;
                this.expanded = false;
            } else {
                this.currentLitChannel = index;
                this.expanded = true;
            }
        }
    },
}
</script>

<style scoped>
.action-link {
  cursor: pointer;
}
</style>